import { supabase } from "../lib/supabase";

/** Supported single sign-on providers. */
export type OAuthProvider = "google";

/**
 * Start the SSO sign-in flow.
 *
 * Supabase redirects to the provider and back to `/login`, where the browser
 * client's `detectSessionInUrl` completes the session. New accounts are gated by
 * the closed-beta cap (`app_config.max_users`) through the `before_user_created`
 * auth hook, and a full beta comes back to `/login` with its wording.
 *
 * The callback targets `/login`, not `/`: the app root immediately redirects to
 * `/login`, and that rewrite would drop the `?error=…` params a rejected
 * sign-in arrives with.
 */
export async function signInWithProvider(
  provider: OAuthProvider,
): Promise<void> {
  const { error } = await supabase.auth.signInWithOAuth({
    provider,
    options: { redirectTo: `${window.location.origin}/login` },
  });
  if (error) throw error;
}
